export const listingManager = {
  header: {
    title: "Anúncios",
    newListingTitle: "Novo anúncio",
    reorderExit: "Sair do modo de reordenação",
    reorder: "Reordenar anúncios",
    done: "Concluído",
    sort: "Ordenar",
    searchPlaceholder: "Buscar…",
    searchClear: "Limpar",
    reorderHint: "Arraste para alterar a ordem",
  },
  globalBtn: {
    title: "Configurações globais",
    sub: "Identidade e novas reservas · toda a conta",
  },
  list: {
    of: "de",
    listingSingular: "anúncio",
    listingPlural: "anúncios",
    unitSingular: "unidade",
    unitPlural: "unidades",
    retry: "Tentar novamente",
    noResults: 'Nenhum resultado para "{query}"',
    viewUnits: "Ver unidades",
    loadingUnits: "Carregando unidades…",
    refuerzaA: "Reforça {name}: por agora recolhe as suas reservas do canal",
    noUnits: "Nenhuma unidade",
    dragToMove: "Arraste para mover",
    unitFallback: "Unidade {n}",
  },
  empty: {
    title: "Selecione um anúncio",
    sub: "Escolha um anúncio no painel à esquerda para gerenciar suas configurações.",
  },
  create: {
    title: "Novo anúncio",
    subtitle: "Crie um anúncio para agrupar suas unidades.",
    nameLabel: "Nome do anúncio",
    namePlaceholder: "Ex.: Loft no Centro",
    typeLabel: "Tipo de acomodação",
    currencyLabel: "Moeda",
    currencyHint: "A moeda não pode ser alterada depois que o anúncio é criado.",
    submit: "Criar anúncio",
    nameRequired: "O nome é obrigatório.",
    errorCreate: "Não foi possível criar o anúncio.",
    successCreate: "Anúncio criado com sucesso.",
  },
  delete: {
    titleListing: "Excluir anúncio",
    titleUnit: "Excluir unidade",
    text: "Ele será removido do WACheckin. Estas alterações não podem ser desfeitas. Para confirmar, digite o nome:",
    placeholderListing: "Nome do anúncio",
    placeholderUnit: "Nome da unidade",
    deleting: "Excluindo…",
    confirm: "Excluir",
    errorDelete: "Não foi possível excluir.",
    successListing: "Anúncio excluído com sucesso.",
    successUnit: "Unidade excluída com sucesso.",
  },
  propertyTypes: {
    apartment: "Apartamento",
    villa: "Vila",
    hotel: "Hotel",
    camping: "Camping",
  },
  propertyTypeLabels: {
    apartment: "Apartamento",
    house: "Casa",
    villa: "Vila",
    hotel: "Hotel",
    room: "Quarto",
    studio: "Estúdio",
    fallback: "Acomodação",
  },
  toast: {
    errorLoad: "Erro ao carregar os anúncios.",
    orderSaved: "Ordem salva com sucesso.",
    errorOrder: "Não foi possível salvar a ordem.",
    nameUpdated: "Nome atualizado.",
    errorName: "Não foi possível atualizar o nome.",
  },
  common: {
    cancel: "Cancelar",
  },
  globalConfig: {
    hero: {
      title: "Configurações globais",
      subPre: "Configurações do Agente de IA que se aplicam a",
      subStrong: "todas as suas acomodações",
      subPost: ".",
    },
    waba: {
      checking: "Verificando conexão…",
      connected: "Conectado",
      start: "Comece aqui",
      titleConnected: "WhatsApp Business",
      titleDisconnected: "Conectar o WhatsApp Business",
      checkingSub: "Verificando o status do seu número…",
      numberPrefix: "Número",
      verified: "verificado e pronto para enviar ✓",
      pending: "verificação pendente",
      linked: "Sua conta do WhatsApp Business está vinculada.",
      linkPrompt: "Vincule seu número para que o agente possa responder e enviar mensagens aos seus hóspedes no WhatsApp.",
      manage: "Gerenciar",
      connect: "Conectar",
    },
    sectionLabel: "Geral · toda a conta",
    badgeDefault: "IA ✨",
    requiresWaba: "Requer o WhatsApp Business conectado",
    notContracted: "Não incluído no seu plano. Fale connosco para o ativar.",
    cards: {
      general: {
        title: "Configurações gerais",
        sub: "Identidade e estilo do agente",
      },
      newBookings: {
        title: "Novas reservas",
        sub: "Primeiro contato, dúvidas e link de reserva",
      },
      voiceAgent: {
        title: "Agente de IA por voz",
        sub: "Atende chamadas telefônicas",
        badge: "NOVO",
      },
    },
    foot: {
      pre: "Estas configurações são",
      strong: "exclusivas da sua conta",
      post: ": alterá-las aqui aplica-as automaticamente a todos os anúncios. O restante da configuração (check-in, acesso, preços…) permanece por anúncio.",
    },
  },
};
